import React, { useEffect } from "react"
import { NumberFieldSeeker } from "@ui-seeker/core"
import { useReportFormInfo } from "Pages/ReportsAlerts/Reports/@hooks"
import { reportFormData, useCsv } from "Pages/ReportsAlerts/Reports/@signals"
import { object, string } from "yup"
import { isEmpty } from "@ui-seeker/utils"


export default function DaysToMonitorField() {

	const {
		daysMonitorized,
		setDaysMonitorizedInfo,
		error
	} = useReportFormInfo(
		reportFormData.peek().daysMonitorized,
		"daysMonitorized",
		object({
			daysMonitorized: string()
				.required("Days must comprehend between 1 and 365")
				.test("minMax", "Days must comprehend between 1 and 365", () => +daysMonitorized > 0 && +daysMonitorized < 366)
		}))

	useEffect(() => {
		return () => {
			if (!isEmpty(reportFormData.value)) setDaysMonitorizedInfo(null, false)
		}
	}, [useCsv.value])

	return <NumberFieldSeeker
		label="Days to monitor"
		value={daysMonitorized || ""}
		onChange={e => setDaysMonitorizedInfo(e.target.value)}
		error={error}
	/>
}